"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsToCss = void 0;
var jsToCss = function (content, selector) {
    return "\n".concat(selector, " {\n  ").concat(Object.entries(content[selector])
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, ": ").concat(value, ";");
    })
        .join('\n  '), "\n}");
};
exports.jsToCss = jsToCss;
//# sourceMappingURL=jsToCss.js.map